export const airconDeals = [
    // {
    //   title: "General Cleaning Service",
    //   unit: 1,
    //   cost: 43,
    //   originalCost: 50,
    //   image: "blog/living/aircon/cleaning-aircon-with-brush.jpg",
    //   description: `Wall mounted only

    //   <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`
    // },
    {
      title: "General Service",
      unit: 2,
      unitType: "wall",
      serviceType: "general",
      cost: 59.84,
      originalCost: 60,
      image: "blog/living/aircon/technician-assembling-aircon-after-chemical-wash.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "General Service",
      unit: 3,
      unitType: "wall",
      serviceType: "general",
      cost: 76.65,
      originalCost: 90,
      image: "blog/living/aircon-installation.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "General Service",
      unit: 4,
      unitType: "wall",
      serviceType: "general",
      cost: 93.45,
      originalCost: 100,
      image: "blog/living/cleaning-aircon-filter.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "General Service",
      unit: 5,
      unitType: "wall",
      serviceType: "general",
      cost: 105.66,
      originalCost: 125,
      image: "blog/living/aircon/washing-ac-cover-with-water.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "General Service",
      unit: 6,
      unitType: "wall",
      serviceType: "general",
      cost: 122.47,
      originalCost: 150,
      image: "aircon/technician-repair-aircon.png",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "General Service",
      unit: 7,
      unitType: "wall",
      serviceType: "general",
      cost: 139.28,
      originalCost: 175,
      image: "blog/living/aircon-installation.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "General Service",
      unit: 1,
      unitType: "ceiling",
      serviceType: "generalCeiling",
      cost: 59.62,
      originalCost: 65,
      image: "blog/living/aircon/technician-assembling-aircon-after-chemical-wash.jpg",
      description: `Ceiling mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "General Service",
      unit: 2,
      unitType: "ceiling",
      serviceType: "generalCeiling",
      cost: 118.18,
      originalCost: 130,
      image: "blog/living/aircon/technician-assembling-aircon-after-chemical-wash.jpg",
      description: `Ceiling mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "General Service",
      unit: 3,
      unitType: "ceiling",
      serviceType: "generalCeiling",
      cost: 151.37,
      originalCost: 160,
      image: "blog/living/aircon/technician-assembling-aircon-after-chemical-wash.jpg",
      description: `Ceiling mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "General Service",
      unit: 4,
      unitType: "ceiling",
      serviceType: "generalCeiling",
      cost: 184.57,
      originalCost: 200,
      image: "blog/living/aircon/technician-assembling-aircon-after-chemical-wash.jpg",
      description: `Ceiling mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "General Service",
      unit: 5,
      unitType: "ceiling",
      serviceType: "generalCeiling",
      cost: 208.68,
      originalCost: 240,
      image: "blog/living/aircon/technician-assembling-aircon-after-chemical-wash.jpg",
      description: `Ceiling mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Chemical Wash",
      unit: 1,
      unitType: "wall",
      serviceType: "chemicalWash",
      cost: 84.64,
      originalCost: 120,
      image: "blog/living/aircon/removing-chemical-from-aircon-with-jet-spray.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Chemical Wash",
      unit: 2,
      unitType: "wall",
      serviceType: "chemicalWash",
      cost: 165.05,
      originalCost: 240,
      image: "blog/living/aircon/technician-assembling-aircon-after-chemical-wash.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Chemical Wash",
      unit: 3,
      unitType: "wall",
      serviceType: "chemicalWash",
      cost: 226.41,
      originalCost: 360,
      image: "aircon/aircon-chemical-wash.png",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Chemical Wash",
      unit: 4,
      unitType: "wall",
      serviceType: "chemicalWash",
      cost: 287.78,
      originalCost: 480,
      image: "aircon/aircon-chemical-wash.png",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Chemical Wash",
      unit: 5,
      unitType: "wall",
      serviceType: "chemicalWash",
      cost: 349.14,
      originalCost: 600,
      image: "blog/living/aircon/washing-ac-cover-with-water.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Chemical Wash",
      unit: 6,
      unitType: "wall",
      serviceType: "chemicalWash",
      cost: 410.50,
      originalCost: 720,
      image: "aircon/aircon-chemical-wash.png",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    // Chemical Hydro Wash (Oct 2026, Singapore only): new, so no originalCost
    {
      title: "Chemical Hydro Wash",
      unit: 1,
      unitType: "wall",
      serviceType: "chemicalHydroWash",
      cost: 121.44,
      originalCost: 0,
      image: "blog/living/aircon/removing-chemical-from-aircon-with-jet-spray.jpg",
      description: `Wall mounted only

      <div>Chemical hydro wash goes further than a chemical wash without a full strip-down: the front panel, filters, blower wheel and drain tray are removed, the coil and blower are chemically treated and rinsed with a high-pressure water jet, and the unit is reassembled and tested.</div>`
    },
    {
      title: "Chemical Hydro Wash",
      unit: 2,
      unitType: "wall",
      serviceType: "chemicalHydroWash",
      cost: 236.81,
      originalCost: 0,
      image: "blog/living/aircon/removing-chemical-from-aircon-with-jet-spray.jpg",
      description: `Wall mounted only

      <div>Chemical hydro wash goes further than a chemical wash without a full strip-down: the front panel, filters, blower wheel and drain tray are removed, the coil and blower are chemically treated and rinsed with a high-pressure water jet, and the unit is reassembled and tested.</div>`
    },
    {
      title: "Chemical Hydro Wash",
      unit: 3,
      unitType: "wall",
      serviceType: "chemicalHydroWash",
      cost: 324.85,
      originalCost: 0,
      image: "blog/living/aircon/removing-chemical-from-aircon-with-jet-spray.jpg",
      description: `Wall mounted only

      <div>Chemical hydro wash goes further than a chemical wash without a full strip-down: the front panel, filters, blower wheel and drain tray are removed, the coil and blower are chemically treated and rinsed with a high-pressure water jet, and the unit is reassembled and tested.</div>`
    },
    {
      title: "Chemical Hydro Wash",
      unit: 4,
      unitType: "wall",
      serviceType: "chemicalHydroWash",
      cost: 412.90,
      originalCost: 0,
      image: "blog/living/aircon/removing-chemical-from-aircon-with-jet-spray.jpg",
      description: `Wall mounted only

      <div>Chemical hydro wash goes further than a chemical wash without a full strip-down: the front panel, filters, blower wheel and drain tray are removed, the coil and blower are chemically treated and rinsed with a high-pressure water jet, and the unit is reassembled and tested.</div>`
    },
    {
      title: "Chemical Hydro Wash",
      unit: 5,
      unitType: "wall",
      serviceType: "chemicalHydroWash",
      cost: 500.94,
      originalCost: 0,
      image: "blog/living/aircon/removing-chemical-from-aircon-with-jet-spray.jpg",
      description: `Wall mounted only

      <div>Chemical hydro wash goes further than a chemical wash without a full strip-down: the front panel, filters, blower wheel and drain tray are removed, the coil and blower are chemically treated and rinsed with a high-pressure water jet, and the unit is reassembled and tested.</div>`
    },
    {
      title: "Chemical Overhaul",
      unit: 1,
      unitType: "wall",
      serviceType: "chemicalOverhaul",
      cost: 153.51,
      originalCost: 160,
      image: "blog/living/aircon-overhaul.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Chemical Overhaul",
      unit: 2,
      unitType: "wall",
      serviceType: "chemicalOverhaul",
      cost: 299.35,
      originalCost: 320,
      image: "blog/living/aircon/technician-assembling-aircon-after-chemical-wash.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Chemical Overhaul",
      unit: 3,
      unitType: "wall",
      serviceType: "chemicalOverhaul",
      cost: 410.64,
      originalCost: 480,
      image: "blog/living/aircon/spraying-chemical-on-aircon.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Chemical Overhaul",
      unit: 4,
      unitType: "wall",
      serviceType: "chemicalOverhaul",
      cost: 521.94,
      originalCost: 640,
      image: "blog/living/aircon/technician-assembling-aircon-after-chemical-wash.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Chemical Overhaul",
      unit: 5,
      unitType: "wall",
      serviceType: "chemicalOverhaul",
      cost: 633.23,
      originalCost: 800,
      image: "aircon/aircon-chemical-wash.png",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Chemical Overhaul",
      unit: 6,
      unitType: "wall",
      serviceType: "chemicalOverhaul",
      cost: 744.53,
      originalCost: 960,
      image: "blog/living/aircon/spraying-chemical-on-aircon.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Gas Refill Full Tank",
      unit: 1,
      unitType: "outdoor",
      serviceType: "gasRefill",
      cost: 147.20,
      originalCost: 160,
      image: "blog/living/aircon-gas.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Gas Refill Full Tank",
      unit: 2,
      unitType: "outdoor",
      serviceType: "gasRefill",
      cost: 294.40,
      originalCost: 320,
      image: "blog/living/aircon/refrigerant-gas-410A.png",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Gas Refill Full Tank",
      unit: 3,
      unitType: "outdoor",
      serviceType: "gasRefill",
      cost: 441.6,
      originalCost: 480,
      image: "blog/living/aircon/refrigerant-gas-R22.png",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Gas Refill Half Tank",
      unit: 1,
      unitType: "outdoor",
      serviceType: "gasRefillHalf",
      cost: 106.72,
      originalCost: 116,
      image: "blog/living/aircon-gas.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Gas Refill Half Tank",
      unit: 2,
      unitType: "outdoor",
      serviceType: "gasRefillHalf",
      cost: 213.44,
      originalCost: 232,
      image: "blog/living/aircon/refrigerant-gas-410A.png",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Gas Refill Half Tank",
      unit: 3,
      unitType: "outdoor",
      serviceType: "gasRefillHalf",
      cost: 320.16,
      originalCost: 348,
      image: "blog/living/aircon/refrigerant-gas-R22.png",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Compressor General Cleaning",
      unit: 1,
      unitType: "outdoor",
      serviceType: "compressorCleaning",
      cost: 67.53,
      originalCost: 73.4,
      image: "blog/living/aircon-condenser.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Compressor General Cleaning",
      unit: 2,
      unitType: "outdoor",
      serviceType: "compressorCleaning",
      cost: 132.30,
      originalCost: 143.8,
      image: "blog/living/aircon-condenser-cleaning.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Compressor General Cleaning",
      unit: 3,
      unitType: "outdoor",
      serviceType: "compressorCleaning",
      cost: 194.06,
      originalCost: 214.2,
      image: "blog/living/air-conditioner-condenser-cleaning.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Compressor Chemical Cleaning",
      unit: 1,
      unitType: "outdoor",
      serviceType: "compressorChemicalCleaning",
      cost: 108.93,
      originalCost: 118.4,
      image: "blog/living/aircon/aircon-condenser-cleaning-with-jet-spray.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Compressor Chemical Cleaning",
      unit: 2,
      unitType: "outdoor",
      serviceType: "compressorChemicalCleaning",
      cost: 215.10,
      originalCost: 233.8,
      image: "aircon/aircon-compressor-cleaning.png",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    },
    {
      title: "Compressor Chemical Cleaning",
      unit: 3,
      unitType: "outdoor",
      serviceType: "compressorChemicalCleaning",
      cost: 321.26,
      originalCost: 349.2,
      image: "blog/living/aircon-overhaul.jpg",
      description: `Wall mounted only

      <div>During general aircon servicing, the technician follows six vital steps: cleaning air filters and covers, cleaning the evaporator coil, clearing drain pan, vacuuming the drainage pipe, checking the outdoor unit's performance and recommending additional cleaning if necessary (at an extra cost), and monitoring the refrigerant gas levels to ensure optimal cooling efficiency.</div>`        
    }
  ]